import { render, staticRenderFns } from "./DirectlyUnderUserList.vue?vue&type=template&id=be93c972"
import script from "./DirectlyUnderUserList.vue?vue&type=script&lang=js"
export * from "./DirectlyUnderUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports